// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"948":"820b656420c896955adb","12974":"778212b1b080750f4514","50169":"3fb019d705b47831c1a3","90768":"1c812180e3967968f973","97049":"c58b9daa55c2bca380ef"}[chunkId] + ".min.js";
};